<template>
  <div class="c-add-break" @click="close">
    <n-loader :loading="$var('load')" />
    <div class="form" @click.stop>
      <div class="title main">Открытие перерыва</div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите время перерыва:
        </div>
        <div class="time-selector">
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('hour')"
            @input="onTimeInput('hour', 23)"
            @blur="onBlurPad('hour')"
          />
          :
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('minute')"
            @input="onTimeInput('minute', 59)"
            @blur="onBlurPad('minute')"
          />
        </div>
      </div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите дату перерыва:
        </div>
        <c-date-picker v-if="preDate === null" :date.sync="date" />
        <c-date-picker v-else :pre-date="[preDate]" :date.sync="date" />
      </div>

      <div class="time-selector-wrapper">
        <div class="title">
          Укажите тип перерыва:
        </div>
        <n-select class="new-select" readonly :data="types" :value.sync="selectedType" />
      </div>
      <div v-if="$var('danger')" class="time-selector-wrapper">
        <div class="title danger">
          {{ $var('danger') }}
        </div>
      </div>
      <div class="buttons">
        <n-button class="cancel" @click="close">Отмена</n-button>
        <n-button @click="add">Добавить</n-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CAddBreak',
  props: {
    userId: {
      type: Number,
      required: true,
    },
    preDate: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      companyId: $app.auth.user().companyId,
      hours: [],
      minutes: [],
      date: null,
      selectedType: {},
      types: [
        { value: 'break15', title: '15 минут', },
        { value: 'break30', title: '30 минут', },
        { value: 'break60', title: '60 минут', },
      ],
    }
  },
  created() {
    this.generateHours()
    this.$form.init({
      hour: {},
      minute: {},
    })
    if (this.preDate) {
      this.date = this.preDate
    }
    this.$form.rules({
      hour: [ 'required', ],
      minute: [ 'required', ],
    })
  },
  methods: {
    onTimeInput(field, max) {
      let value = this.$form.get(field)

      value = value.replace(/\D/g, '')

      if (value.length > 2) {
        value = value.slice(0, 2)
      }

      const num = parseInt(value || '0')

      if (num > max) {
        value = max.toString().padStart(2, '0')
      }

      this.$form.set(field, value)
    },
    onBlurPad(field) {
      const val = this.$form.get(field)
      if (val !== undefined && val !== null && val.length === 1) {
        const padded = val.padStart(2, '0')
        this.$form.set(field, padded)
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    generateHours() {
      this.hours = Array.from({ length: 24, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
      this.minutes = Array.from({ length: 60, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
    },
    add() {
      if (this.$form.check() && this.date && Object.keys(this.selectedType).length > 0) {
        this.$var('load', true)
        const data = {
          date: this.date,
          hours: this.$form.get('hour') + '',
          minutes: this.$form.get('minute') + '',
          userId: this.userId,
          type: this.selectedType.value,
          status: 'start',
        }
        $api.breaks.create(this.companyId, this.userId, data).then(() => {
          this.close()
        }).finally(() => {
          this.$var('load', false)
        })
      } else {
        this.$var('danger', 'Есть неправильно заполненные поля')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-add-break {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #00000080;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .buttons {
     display: flex;
     align-items: center;
     justify-content: space-between;
     .n-button {
       background-color: var(--primary);
       color: #FFFFFF;
       border: none;
       border-radius: 12px;
       height: 48px;
       padding: 0 24px;

       &.cancel {
         background-color: #ffffff;
         color: var(--primary);
         font-weight: 700;
         border: 1px solid var(--primary);
       }
     }
   }
  .buttons {
    width: 100%;
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 400px;
    min-height: 200px;
    border-radius: 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        &.danger {
          width: 100%;
          color: red;
          text-align: center;
        }
        margin-right: 15px;
        font-weight: normal;
        font-size: 14px;
        color: #000000;
      }
    }

    .new-time-input {
      width: 50px;
      border-radius: 12px;
      text-align: center;
      box-shadow: 0 0 0 1px #e0e3f0;
      margin: 0 2px;

      ::v-deep {
        .n-input {
          border: none !important;
        }

        .n-content {
          width: 50px;
          height: 40px;
          padding: 6px 10px 6px 15px;
        }
      }
    }

    .time-selector {
      display: flex;
      align-items: center;
      justify-content: start;
      ::v-deep {
        .n-select {
          .v-select {
            padding: 2px;
          }
          .n-icon {
            display: none;
          }
          .n-text {
            text-align: center;
          }
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
          width: 60px;
          .n-content {
            padding: 0;
          }
          .n-icon {
            margin: 0 !important;
          }
          .n-popup-content {
            width: 60px;
            .n-dropdown-item {
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .n-item {
              text-align: center;
            }
          }
          .n-wrapper {
            padding: 0 5px;
            width: 60px;
          }
          .n-dropdown {
            width: 60px;
          }
        }
      }
    }
  }
}
</style>
